export default {
    changeState(state, payload) {
        state.organizations = payload.organizations;
        state.searchString = payload.searchString;
        state.creativeCode = payload.creativeCode;
        state.pageNumber = payload.pageNumber;
        state.pageSize = payload.pageSize;
    },
    clearState(state) {
        state.organizations = [];
        state.searchString = '';
        state.creativeCode = '';
        state.pageNumber = 1,
        state.pageSize = 25
    }
}